import React from "react";
import { FaMapMarkerAlt } from "react-icons/fa";
import { mapsSearchUrl } from "../utils/googleMaps";
import "../assets/css/AddressSearch.css";

/** "View on Google Maps" for an address; renders nothing when the address is empty. */
function MapLink({ parts, label = "View on Google Maps", className = "" }) {
  const url = mapsSearchUrl(parts);
  if (!url) return null;
  return (
    <a className={`address-map-link ${className}`.trim()} href={url} target="_blank" rel="noreferrer">
      <FaMapMarkerAlt /> {label}
    </a>
  );
}

export default MapLink;
